require('../../node_modules/magnific-popup/dist/jquery.magnific-popup')

module.exports = {
  init: () => {
    $('.overlay-trigger').magnificPopup({
      type: 'inline',
      mainClass: 'overlay--fade',
      closeOnBgClick: false
    })
  }
}
